<script setup lang="ts">
useSeoMeta({
  title: 'Guidance for Controlled Quality Operations — QikSolve',
  description: 'Explore QikSolve guidance for practical quality systems, regulatory context, SharePoint governance, ISO 9001, validation, and governed AI.',
});

const guides = [
  {
    icon: 'i-heroicons-clipboard-document-check',
    title: 'ISO 9001 Service',
    description:
      'Practical ISO 9001 guidance and service support for leadership, process ownership, documented information, review, and continual improvement.',
    route: '/product/iso-9001',
  },
  {
    icon: 'i-heroicons-chart-bar-square',
    title: 'Quality Dashboards and Reporting',
    description: 'Power BI templates and reporting packs, automatically refreshed and accessible from anywhere.',
    route: '/product/quality-dashboards',
  },
  {
    icon: 'i-heroicons-adjustments-horizontal',
    title: 'Practical GxP Quality Systems',
    description:
      'A practical pathway for designing, validating, operating, and sustaining controlled quality systems alongside everyday quality work.',
    route: '/product/quality-systems',
  },
  {
    icon: 'i-heroicons-arrow-path-rounded-square',
    title: 'Systems Thinking for Regulated Operations',
    description:
      'A practical way to see how people, process, information, technology, decisions, and feedback work together across a regulated operation.',
    route: '/product/systems-thinking-for-regulated-operations',
  },
  {
    icon: 'i-heroicons-shield-check',
    title: 'SharePoint Online Governance and Configuration',
    description: 'Structured, compliant SharePoint environments configured to FDA, TGA and PIC/S guidelines.',
    route: '/product/sharepoint-governance',
  },
  {
    icon: 'i-heroicons-scale',
    title: 'Regulatory Compliance, Validation and CSV Support',
    description:
      'Validation protocols, Computer System Validation (CSV) documentation, and ongoing compliance support for Microsoft 365.',
    route: '/product/regulatory-compliance',
  },
  {
    icon: 'i-heroicons-cpu-chip',
    title: 'Agentic AI Governance',
    description:
      'A risk-tiered governance framework for generative AI and agentic workflows in GMP and GMP-adjacent operations.',
    route: '/product/agentic-ai-governance',
  },
  {
    icon: 'i-heroicons-academic-cap',
    title: 'Training and Enablement',
    description: 'Role-based training programs covering platform adoption, validation practice, and AI governance.',
    route: '/product/training',
  },
];
</script>

<template>
  <div>
    <section class="bg-gradient-to-b from-brand-50 to-white">
      <div class="max-w-5xl mx-auto px-4 py-16 text-center">
        <h1 class="text-3xl sm:text-4xl font-heading font-bold mb-3 text-gray-900">
          Guidance
        </h1>
        <p class="text-gray-600 max-w-2xl mx-auto">
          Explore the practical decisions that shape controlled quality operations. These guides help
          your team understand a problem, assess fit, and identify the right service or product path.
        </p>
      </div>
    </section>

    <section class="max-w-5xl mx-auto px-4 py-16 grid gap-6 md:grid-cols-2">
      <h2 class="sr-only">
        Guidance topics
      </h2>
      <ServiceCard
        v-for="guide in guides"
        :key="guide.route"
        :icon="guide.icon"
        :title="guide.title"
        :description="guide.description"
        :to="guide.route"
      />
    </section>
  </div>
</template>
